/*
 * File: PatientInformationPage.js
 * Project: mp-mobile-app
 *
 * Created by Jennifer Loecker on 09/12/2019
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Shows the patient information page
 */
import React from "react";
import { observer } from "mobx-react";
import PatientStore from "services/patients/store/PatientStore";
import PatientViewPage from "../components/PatientViewPage";
import PersonIcon from "@material-ui/icons/Person";
import PatientEditPage from "../components/PatientEditPage";
import UIFormDialog from "components/ui/UIFormDialog";
import UIProgress from "components/ui/UIProgress";
import UIFab from "components/ui/UIFab";
import { Toolbar } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import PatientChart from "services/patients/topofthechart/PatientChart";
import PropTypes from "prop-types";
import MainHeader from "components/MainHeader";
import RecentPatientActions from "services/patients/store/RecentPatientActions";
import { StoreContext } from "utils/useStore";

const styles = theme => ({
  toolbar: {
    padding: theme.spacing(2.5),
    display: "block",
    paddingBottom: theme.spacing(0.5),
    marginTop: theme.spacing(2.5)
  }
});

class PatientInformationPage extends React.Component {
  static contextType = StoreContext;

  constructor(props) {
    super(props);
    this.state = {
      editPatientOpen: false,
      loadingEditedPatient: false
    };
  }

  get patientStore() {
    return this.context.getStore(PatientStore);
  }

  toggleEditPatientDialog = () => {
    this.setState({
      editPatientOpen: !this.state.editPatientOpen
    });
  };

  editPatientCallBack = async () => {
    this.setState({ loadingEditedPatient: true });
    await this.patientStore.find(RecentPatientActions);
    this.setState({ loadingEditedPatient: false });
    this.toggleEditPatientDialog();
  };

  editPatient = () => {
    return (
      <PatientEditPage
        patient={this.patientStore.editPatient}
        parentCallBack={this.editPatientCallBack}
      />
    );
  };

  render() {
    let { editPatientOpen, loadingEditedPatient } = this.state;
    let { patientModel } = this.patientStore;
    const { classes } = this.props;
    return (
      <React.Fragment>
        {loadingEditedPatient && <UIProgress />}

        {!loadingEditedPatient && (
          <React.Fragment>
            <PatientChart />
            {/* This div is needed for formatting purposes */}
            <div>
              <Toolbar className={classes.toolbar}>
                <MainHeader
                  pageTitle="Patient Information"
                  pageSubtitle="Patient"
                />
              </Toolbar>
            </div>
            <PatientViewPage patient={patientModel} />
            <UIFab
              icon={<PersonIcon />}
              name={"Edit Patient"}
              handleClick={this.toggleEditPatientDialog}
            />

            <UIFormDialog
              open={editPatientOpen}
              toggleDialog={this.toggleEditPatientDialog}
              title={"Edit Patient"}
              viewPage={this.editPatient}
            />
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

PatientInformationPage.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(observer(PatientInformationPage));
